module.exports = __webpack_public_path__ + "img/thumbnail-new.9cee0ac8.png";